export const calculateSubjectAttendancePercentage = (presentCount, totalSessions) => {
    if (totalSessions === 0 || presentCount === 0) {
        return 0;
    }
    const percentage = (presentCount / totalSessions) * 100;
    return percentage.toFixed(2); // Limit to two decimal places
};


export const groupAttendanceBySubject = (subjectAttendance) => {
    const attendanceBySubject = {};

    subjectAttendance.forEach((attendance) => {
        // Handle cases where subName might be null (orphaned subjects or general attendance)
        const subName = attendance.subName ? attendance.subName.subName : "General Attendance";
        const sessions = attendance.subName ? (attendance.subName.sessions || 0) : 1; // Fallback to 1 if it's general
        const subId = attendance.subName ? attendance.subName._id : "general";

        if (!attendanceBySubject[subName]) {
            attendanceBySubject[subName] = {
                present: 0,
                absent: 0,
                late: 0,
                sessions: sessions,
                allData: [],
                subId: subId
            };
        }
        
        if (attendance.status === "Present") {
            attendanceBySubject[subName].present++;
        } else if (attendance.status === "Absent") {
            attendanceBySubject[subName].absent++;
        } else if (attendance.status === "Late") {
            attendanceBySubject[subName].late++;
            attendanceBySubject[subName].present++; // Late counts as present in most logic
        }

        attendanceBySubject[subName].allData.push({
            date: attendance.date,
            status: attendance.status,
        });
    });
    return attendanceBySubject;
}

export const calculateOverallAttendancePercentage = (subjectAttendance) => {
    let totalSessionsSum = 0;
    let presentCountSum = 0;
    const uniqueSubIds = new Set();

    subjectAttendance.forEach((attendance) => {
        // Safe access to subName and sessions
        const subId = attendance.subName ? attendance.subName._id : "general";
        
        if (!uniqueSubIds.has(subId)) {
            const sessions = attendance.subName ? parseInt(attendance.subName.sessions || 0) : 1;
            totalSessionsSum += sessions;
            uniqueSubIds.add(subId);
        }

        // Late also counts as a form of presence in terms of percentage usually
        if (attendance.status === "Present" || attendance.status === "Late") {
            presentCountSum++;
        }
    });

    if (totalSessionsSum === 0) {
        return 0;
    }

    return (presentCountSum / totalSessionsSum) * 100;
};